import { render, staticRenderFns } from "./liveorder.vue?vue&type=template&id=70bf8bec&scoped=true&"
import script from "./liveorder.vue?vue&type=script&lang=js&"
export * from "./liveorder.vue?vue&type=script&lang=js&"
import style0 from "./liveorder.vue?vue&type=style&index=0&id=70bf8bec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf8bec",
  null
  
)

export default component.exports